<template>
  <div class="page-loader text-center py-5">
    <div class="spinner-border" role="status" :style="accentColor ? `color:${accentColor}` : ''"></div>
    <p class="mt-2 text-muted small">{{ message }}</p>
  </div>
</template>

<script>
// Shared loading block for pages that fetch data over the network (PocketBase
// lists, price/RPC lookups) — same spinner-border + message shape already used
// inline in TxTable.vue and the wallet "Scanning tokens…" rows, extracted here
// so slower pages don't fall back to a static "Loading…" line with no animation.
export default {
  name: 'PageLoader',
  props: {
    message: { type: String, default: 'Loading…' },
    accentColor: { type: String, default: '' },
  },
};
</script>

<style scoped>
.page-loader { padding-top: 3rem !important; padding-bottom: 3rem !important; }
</style>
